<template>
  <FormulateForm :name="name" :values="newValues" @input="handleFormChange" @submit="handleSubmit">
    <slot :loading="loading" :submittable="submittable" :newValues="newValues" />
  </FormulateForm>
</template>

<script>
import isEmpty from 'lodash.isempty'
import isEqual from 'lodash.isequal'
import assign from 'lodash.assign'
import pick from 'lodash.pick'
import keys from 'lodash.keys'
import { generate } from 'shortid'
export default {
  props: {
    values: {
      type: Object,
      default: () => ({})
    },
    name: {
      type: String,
      default: generate
    },
    submit: {
      type: Function,
      required: true
    }
  },
  created() {
    this.newValues = { ...this.values }
  },
  data: () => ({
    loading: false,
    newValues: null
  }),
  computed: {
    modified() {
      return !isEqual(this.values, this.newValues)
    },
    submittable() {
      return isEmpty(this.values) ? true : this.modified
    }
  },
  methods: {
    async handleFormChange(values) {
      this.newValues = assign(this.newValues, pick(values, keys(this.newValues)))
    },
    async handleSubmit() {
      this.loading = true
      try {
        await this.submit(this.newValues)
        this.$notify({ text: 'Success', theme: 'green' })
      } catch (error) {
        console.log(error)
        this.$formulate.reset(this.name, { ...this.values })
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  align-self: flex-end;
  padding: 0 var(--spacing-5);
}
</style>
